export interface SharedEnvironment {
    baseFileNames: string;
    production: boolean;
    baseUrl: string;
    baseReportUrl: string;
    auditApiBaseUrl: string;
    externalVehicleLookupLogo: string;
    externalVehicleLookupName?: string;
    apiPaths: ApiPaths;
    storageKeyUsername: string;
    storageKeyDictionary: string;
    storageKeySelectedBranch: string;
    defaultLanguage: string;
    privacy: string;
    /**
     * Connection string of the Application Insights resource that receives this app's client telemetry. Without one,
     * telemetry never loads (local builds and tests).
     */
    appInsightsConnectionString?: string;
    /**
     * The deployment environment this build targets (development, staging, production, or local), sent with telemetry
     * as `deployment.environment.name` so one client resource can be filtered per environment.
     */
    envName?: string;
    menu?: MobileMenuVisibility;
}

/**
 * Per-app overrides for optional mobile side-menu entries. Every field is optional and defaults to
 * shown when omitted, so apps that do not set it (e.g. omni-mobile) keep the full menu unchanged.
 */
export interface MobileMenuVisibility {
    /** Whether the Privacy Policy entry is shown. Defaults to shown when omitted. */
    privacyPolicy?: boolean;
}

interface ApiPaths {
    validateUrl: string;
    login: string;
    branches: string;
    token: string;
    refreshToken: string;
    systemInfo: string;
}

/**
 * Entra ID staff sign-in configuration. Each environment carries its own app registration, so a
 * token obtained through one environment's flow is not honoured by another.
 */
export interface EntraStaffAuthConfig {
    /** Directory (tenant) id hosting the staff app registration. */
    tenantId: string;
    /** Application (client) id of the staff app registration, which is also the token audience. */
    clientId: string;
    /** Redirect target registered as an SPA reply url. Empty falls back to the window origin. */
    redirectUri: string;
}

export const sharedEnvironment: SharedEnvironment = {
    baseFileNames: 'omni',
    production: false,
    baseUrl: 'https://localhost:7055/api/',
    baseReportUrl: 'https://localhost:7056/api/',
    auditApiBaseUrl: 'https://localhost:7057/api/',
    externalVehicleLookupLogo: 'public/carfax.png',
    externalVehicleLookupName: 'Carfax',
    apiPaths: {
        validateUrl: 'v1/systeminfo/validate-url',
        login: 'v1/authentication/login',
        branches: 'Branch',
        token: 'oauth2/token',
        refreshToken: 'v1/authentication/token/refresh',
        systemInfo: 'Rest/External/V1/SystemInfo',
    },
    storageKeyUsername: 'username',
    storageKeyDictionary: 'dictionary',
    storageKeySelectedBranch: 'selectedBranch',
    defaultLanguage: 'en-US',
    privacy: 'https://www.example.com/privacy-policy.html',
    appInsightsConnectionString: undefined,
};
